<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import samples from "../stores/samples";
    import {scrollTo} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import Pagination from "../components/Pagination.svelte";

    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'code', title: 'ΚΩΔΙΚΟΣ', sortable: true, sort_way: 'ASC'},
        {key: 'type', title: 'ΕΙΔΟΣ', sortable: true},
        {key: 'characterization', title: 'ΧΑΡΑΚΤΗΡΙΣΜΟΣ', sortable: true},
        {key: 'client', title: 'ΠΕΛΑΤΗΣ', class: 'hidden-xs'},
        {key: 'order', title: 'ΕΝΤΟΛΗ', class: 'hidden-xs'},
    ];

    const itemsPerPage = [20, 50, 100, 500];

    const load = (loader = LOADER.PAGE) => {
        const onSuccess = result => {
            $samples.list = result.samples;
            $samples.total = result.total;
        }

        const onFailure = err => {
        };


        $samples.search.offset = ($samples.page - 1) * $samples.search.limit;

        R.handle(R.sample.index, $samples.search, onSuccess, onFailure, loader);
    }


    const onSearch = () => {
        $samples.page = 1;
        load();
    }

    const clearSearch = () => {
        samples.clearSearch();
        load();
    }

    const onColumnSort = ({detail}) => {
        $samples.search.sort_field = detail.key;
        $samples.search.sort_way = detail.sort_way;
        load();
    }

    const onPageChange = ({detail}) => {
        $samples.page = detail;
        scrollTo('listing-top', -50);
        load();
    }

    const onEdit = (item) => {
        $samples.selectedId = item.id;
        $samples.scrollY = window.scrollY;
        router.go(`/app/sample/${item.id}`)();
    }


    const initialize = () => {
        // get search criteria from url parameters
        if (window.location.search) {
            let arr = window.location.search.replace("?", "").split("&");
            arr.map(item => {
                let param = item.split("=");
                if (param[0] === 'client_id') {
                    $samples.search.client_id = param[1];
                }
            });
        }

        if (!$samples.list) {
            $samples.page = 1;
            $samples.search.limit = itemsPerPage[0];

            load();
        } else if ($samples.changed) {
            // sample data changed from SampleEdit component
            load(LOADER.NONE);
            $samples.changed = false;
        }

        if ($samples.scrollY != null) {
            // set window scroll position to last edited transfer
            setTimeout(function () {
                window.scrollTo({top: $samples.scrollY});
                $samples.scrollY = null;
            }, 50);

        }
    }

    initialize();
</script>

<PageHeader title="Δείγματα" controls={ pageHeaderControls } on:reload={ load }/>

<div class="panel panel-simple p-2 mb-5">
    <div class="row">
        <div class="col-xl-2 col-lg-3 col-md-2">
            <div class="form-group-sm">
                <input type="text" class="form-control" bind:value="{ $samples.search.code }" on:change={ onSearch }
                       placeholder="κωδικός δείγματος">
            </div>
        </div>
        <div class="col-xl-3 col-lg-2 col-md-4">
            <div class="form-group-sm">
                <input type="text" class="form-control" bind:value="{ $samples.search.type }" on:change={ onSearch }
                       placeholder="είδος">
            </div>
        </div>
        <div class="col-xl-5 col-lg-3 col-md-4">
            <div class="form-group-sm">
                <input type="text" class="form-control" bind:value="{ $samples.search.characterization }" on:change={ onSearch }
                       placeholder="χαρακτηρισμός">
            </div>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-default btn-block text-truncate" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
        </div>
        <div class="col-xl-1 col-lg-2 col-md-3 col-6">
            <button class="btn btn-outline btn-block" on:click={ onSearch }>ΕΥΡΕΣΗ</button>
        </div>
    </div>
</div>

<div class="row align-items-center mb-4" id="listing-top">
    <div class="col-xl-2 col-lg-3 col-md-4 col-7">
        <select class="form-select form-select-sm" bind:value="{ $samples.search.limit }" on:change="{ onSearch }">
            {#each itemsPerPage as item}
                <option value="{ item }">εμφάνιση { item } / σελίδα</option>
            {/each}
        </select>
    </div>
    {#if $samples.list && $samples.list.length}
        <div class="col-xl-10 col-lg-9 col-md-8 col-5">
            <span class="listing-info">Δείγματα: <strong>{ $samples.total }</strong></span>
            <span class="listing-info hidden-xs">Σελίδα: <strong>{ $samples.page }</strong></span>
        </div>
    {/if}
</div>

{#if $samples.list}
    {#if $samples.list.length}
        <table class="table table-list orders-list table-list-border mb-4">
            <TableHeader {tableColumns} on:sort={ onColumnSort }/>
            <tbody>
            {#each $samples.list as item}
                <tr class="row-hover pointer" class:row-selected="{ $samples.selectedId === item.id }"
                    on:click={ () => onEdit(item) }>
                    <td class="code-column">
                        { item.code }
                    </td>
                    <td class="text-gray">
                        { item.type }
                    </td>
                    <td class="text-gray">
                        { item.characterization }
                    </td>
                    <td class="text-gray hidden-xs">
                        {#if item.client}
                            { item.client.company }
                        {/if}
                    </td>
                    <td class="code-column text-gray hidden-xs">
                        {#if item.order}
                            { item.order.code }
                        {/if}
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <Pagination itemsPerPage="{ $samples.search.limit }" totalItems="{ $samples.total }"
                    page="{ $samples.page }"
                    on:change="{ onPageChange }"/>
    {:else}
        <div class="panel panel-simple panel-pad">
            Δεν βρέθηκαν δείγματα.
        </div>
    {/if}
{/if}